import CitiesPage from './CitiesPage';

export { type Props } from './types';

export { generateBreadcrumbs } from './CitiesPage';

export default CitiesPage;
